"use client";

import { BatchConverter } from "@/components/batch-converter";
import { Converter } from "@/components/converter";
import { useProStatus } from "@/hooks/use-pro-status";

export function BatchSection() {
  const isPro = useProStatus();
  return isPro ? <BatchConverter /> : <Converter />;
}
